module.exports = {
    PlaceOrGeographicName: {
        AdministrativeUnit: 0,
        BuildingOrMemorial: 0,
        Country: 0,
        ExtraterrestrialTerritory: 0,
        FictivePlace: 0,
        MemberState: 0,
        NameOfSmallGeographicUnitLyingWithinAnotherGeographicUnit: 0,
        NaturalGeographicUnit: 0,
        ReligiousTerritory: 0,
        TerritorialCorporateBodyOrAdministrativeUnit: 0,
        WayBorderOrLine: 0,
    },
    Person: {
        DifferentiatedPerson: {
            CollectivePseudonym: 0,
            Gods: 0,
            LiteraryOrLegendaryCharacter: 0,
            Pseudonym: 0,
            RoyalOrMemberOfARoyalHouse: 0,
            Spirits: 0,
        },
        UndifferentiatedPerson: 0,
    },
    Family: 0,
    ConferenceOrEvent: {
        SeriesOfConferenceOrEvent: 0,
    },
    CorporateBody: {
        Company: 0,
        FictiveCorporateBody: 0,
        MusicalCorporateBody: 0,
        OrganOfCorporateBody: 0,
        ProjectOrProgram:     0,
        ReligiousAdministrativeUnit: 0,
        ReligiousCorporateBody: 0
    },
    Subject: {
        CharactersOrMorphemes : 0,
        EthnographicName : 0,
        FictiveTerm : 0,
        GroupOfPersons : 0,
        HistoricSingleEventOrEra : 0,
        Language : 0,
        MeansOfTransportWithIndividualName : 0,
        NomenclatureInBiologyOrChemistry : 0,
        ProductNameOrBrandName : 0,
        SoftwareProduct : 0,
        SubjectHeadingSensoStricto: 0,
    },
    Work: {
      Collection: 0,
      CollectiveManuscript: 0,
      Expression: 0,
      Manuscript: 0,
      MusicalWork: 0,
      ProvenanceCharacteristic: 0,
      VersionOfAMusicalWork: 0,
    }
}
